module.exports = __webpack_public_path__ + "static/media/CompareDevicePlans.8bdcd6cc.svg";